/** A shared empty-array instance that maintains referential integrity and avoids re-allocations. */
export const EMPTY_ARRAY: never[] = [];
